<template>
  <div class="nav-container" ref="stepNav">
    <div id="step-nav" class="full-width-nav" ref="steps" :class="{'condensed': condensed}" v-if="!loading">
      <div class="container-fluid step-nav">
        <div class="row text-center">
          <div class="col-sm-3 nav-header">
            <h2 class="text-left text-uppercase font-bold">Steps To<br>Calculate:</h2>
            
            <div to="fuel-costs" class="inline-step ml-auto mr-3 d-md-none" :class="[active >= 0 ? 'active' : '']" @click="goToStep('fuel-costs')">
              <span class="material-icons" :class="[active >= 0  ? 'd-block' : 'd-none']">check</span>
              <span :class="[active >= 0  ? 'd-none' : 'd-block']">1</span>
            </div>
            <div to="equipment-costs" class="inline-step mr-3 d-md-none" :class="[active >= 1 ? 'active' : '']" @click="goToStep('equipment-costs')">
              <span class="material-icons" :class="[active >= 1 ? 'd-block' : 'd-none']">check</span>
              <span :class="[active >= 1 ? 'd-none' : 'd-block']">2</span>
            </div>
            <div to="other-costs" class="inline-step d-md-none" :class="[active >= 2 ? 'active' : '']" @click="goToStep('other-costs')">
              <span class="material-icons" :class="[active >= 2 ? 'd-block' : 'd-none']">check</span>
              <span :class="[active >= 2 ? 'd-none' : 'd-block']">3</span>
            </div>
          </div>

          <div class="col-sm-12 d-md-none">
            <div class="tab-title-mobile py-2 pt-4" data-toggle="collapse" data-target="#collapse-steps" aria-expanded="false" aria-controls="collapse-steps">
              <div class="primary-display">
                <span class="font-heading text-uppercase">{{ activeTitle }}</span>
                <span class="font-heading ml-auto mr-3" v-if="active == 0">{{ formatPriceWhole(fuelCost['annual-cost']) }}</span>
                <span class="font-heading ml-auto mr-3" v-if="active == 1">{{ formatPriceWhole(equipment['annual-cost']) }}</span>
                <span class="font-heading ml-auto mr-3" v-if="active == 2">{{ formatPriceWhole(otherCost['annual-cost']) }}</span>
                <span class="material-icons">expand_more</span>
              </div>
              <div id="collapse-steps" ref="collapseStepMobile" class="collapse collapse-selections">
                <div class="collapse-body">
                  <ul>
                    <li>
                      <div @click="goToStep('fuel-costs')">
                        <div class="inline-step d-md-none" :class="[active >= 0 ? 'active' : '']">
                          <span class="material-icons" :class="[active >= 0 ? 'd-block' : 'd-none']">check</span>
                          <span :class="[active >= 0 ? 'd-none' : 'd-block']">1</span>
                        </div>
                        <span class="font-heading text-uppercase">{{ fuelType == 'electric' ? 'Electricity Costs' : 'Fuel Costs' }}</span>
                        <span class="font-heading ml-auto">{{ formatPriceWhole(fuelCost['annual-cost'] * currencyExchange) }}</span>
                      </div>
                    </li>
                    <li>
                      <div @click="goToStep('equipment-costs')">
                        <div class="inline-step d-md-none" :class="[active >= 1 ? 'active' : '']">
                          <span class="material-icons" :class="[active >= 1 ? 'd-block' : 'd-none']">check</span>
                          <span :class="[active >= 1 ? 'd-none' : 'd-block']">2</span>
                        </div>
                        <span class="font-heading text-uppercase">Equipment Costs</span>
                        <span class="font-heading ml-auto">{{ formatPriceWhole(equipment['annual-cost'] * currencyExchange) }}</span>
                      </div>
                    </li>
                    <li>
                      <div @click="goToStep('other-costs')">
                        <div class="inline-step d-md-none" :class="[active >= 2 ? 'active' : '']">
                          <span class="material-icons" :class="[active >= 2 ? 'd-block' : 'd-none']">check</span>
                          <span :class="[active >= 2 ? 'd-none' : 'd-block']">3</span>
                        </div>
                        <span class="font-heading text-uppercase">Other Costs</span>
                        <span class="font-heading ml-auto">{{ formatPriceWhole(otherCost['annual-cost'] * currencyExchange) }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-3 step-box d-none d-md-block" :class="[active >= 0 ? 'active' : '']" id="step1">
            <div @click="goToStep('fuel-costs')" class="step-tile fixer">
              <div class="inline-step mx-auto" :class="[active >= 0 ? 'active' : '']">
                <span class="material-icons" :class="[active >= 0 ? 'd-block' : 'd-none']">check</span>
                <span :class="[active >= 0 ? 'd-none' : 'd-block']">1</span>
              </div>
              <p class="nav-heading font-heading">{{ fuelType == 'electric' ? 'Electricity' : 'Fuel' }} Costs</p>
              <p class="step-value" v-if="usage == 'miles'" v-html="fuelCost ? formatPriceWhole(fuelCost['annual-cost'] * currencyExchange) : '$0.00'"></p>
              <p class="step-value" v-if="usage == 'hours'" v-html="fuelCost ? formatPriceWhole(fuelCost['annual-cost-hourly'] * currencyExchange) : '$0.00'"></p>
            </div>
          </div>

          <div class="col-sm-3 step-box d-none d-md-block" :class="[active >= 1 ? 'active' : '']" id="step2">
            <div @click="goToStep('equipment-costs')" class="step-tile fixer">
              <div class="inline-step mx-auto" :class="[active >= 1 ? 'active' : '']">
                <span class="material-icons" :class="[active >= 1 ? 'd-block' : 'd-none']">check</span>
                <span :class="[active >= 1 ? 'd-none' : 'd-block']">2</span>
              </div>
              <p class="nav-heading font-heading">Equipment Costs</p>
              <p class="step-value" v-html="equipment ? formatPriceWhole(equipment['annual-cost'] * currencyExchange) : '$0.00'"></p>
            </div>
          </div>

          <div class="col-sm-3 step-box d-none d-md-block" :class="[active >= 2 ? 'active' : '']" id="step3">
            <div @click="goToStep('other-costs')" class="step-tile fixer">
              <div class="inline-step mx-auto" :class="[active >= 2 ? 'active' : '']">
                <span class="material-icons" :class="[active >= 2 ? 'd-block' : 'd-none']">check</span>
                <span :class="[active >= 2 ? 'd-none' : 'd-block']">3</span>
              </div>
              <p class="nav-heading font-heading">Other Costs</p>
              <p class="step-value" v-if="usage == 'miles'" v-html="otherCost ? formatPriceWhole(otherCost['annual-cost'] * currencyExchange) : '$0.00'"></p>
              <p class="step-value" v-if="usage == 'hours'" v-html="otherCost ? formatPriceWhole(otherCost['annual-cost-hourly'] * currencyExchange) : '$0.00'"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepsToCalculateNav',
    props: {
      fuelCost: {},
      equipment: {},
      otherCost: {},
      usage: String,
      active: Number
    },
    data() {
      return {
        activeTitle: '',
        fuelType: '',
        currency: 0,
        scrollPosition: 0,
        condensed: false,
        loading: true
      }
    },
    mounted() {
      this.currencyType = sessionStorage.getItem('currency')
      this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1

      switch (this.$route.name) {
        case 'ElectricFuelCosts':
          this.activeTitle = 'Electricity Costs'
          this.fuelType = 'electric'
          break
        case 'ElectricEquipmentCosts':
          this.activeTitle = 'Equipment Costs'
          this.fuelType = 'electric'
          break
        case 'ElectricOtherCosts':
          this.activeTitle = 'Other Costs'
          this.fuelType = 'electric'
          break
        case 'DieselFuelCosts':
          this.activeTitle = 'Fuel Costs'
          this.fuelType = 'diesel'
          break
        case 'DieselEquipmentCosts':
          this.activeTitle = 'Equipment Costs'
          this.fuelType = 'diesel'
          break
        case 'DieselOtherCosts':
          this.activeTitle = 'Other Costs'
          this.fuelType = 'diesel'
          break
      }
      
        
      $('body').on('click', function() {
        if(window.location.href.indexOf('fuel-costs') > -1) {
            $('.step-box').removeClass('active')
            $('#step1').addClass('active')
        } else if(window.location.href.indexOf('equipment-costs') > -1) {
            $('.step-box').removeClass('active')
            $('#step2').addClass('active')
        } else if(window.location.href.indexOf('other-costs') > -1) {
            $('.step-box').removeClass('active')
            $('#step3').addClass('active')
        }   
      })

      if(window.location.href.indexOf('electric') > -1) {
        $('#fuel-type').text('Electricity')
      } else {
        $('#fuel-type').text('Diesel')
      }

      this.loading = false;

      setTimeout(() => {
        this.$refs.stepNav.style.height = this.$refs.steps.clientHeight + 'px'
      }, 100)

      // sticky nav styling
      window.addEventListener('scroll', this.updateNavOnScroll)

     
    },
    methods: {
      updateNavOnScroll() {
        this.scrollPosition = window.scrollY

        if ( window.scrollY > this.$refs.stepNav.offsetTop) {
          this.condensed = true
        } else {
          this.condensed = false
        }
      },
      goToStep(route) {
        // collapse menu and then navigate
        $('#collapse-steps').collapse('hide')

        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Step Tiles',
          'event_label': route
        })

        setTimeout(() => this.$router.push(route), 300)
      },
      formatPrice(value) {
          let val = (value/1).toFixed(2)
          return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      formatPriceWhole(value) {
          let val = (value/1).toFixed(0)
          return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    }
  }
</script>

<style lang="scss" scoped>
 .router-link-active, 
 .router-link-exact-active,
 .fixer {
   color: inherit;
   text-decoration: inherit;
 }
</style>